export default "__VITE_ASSET__B1nj5iA5__"